// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    Address,
    AddressFromJSON,
    AddressToJSON,
} from './';

/**
 * 
 * @export
 * @interface PayerContact
 */
export interface PayerContact {
    /**
     * The email address for claim submissions
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof PayerContact
     */
    emailClaim?: string;
    /**
     * The email address for reconsiderations and appeals
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof PayerContact
     */
    emailAppeal?: string;
    /**
     * The email address for medical records and supporting documentation
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof PayerContact
     */
    emailDocumentation?: string;
    /**
     * The email address for overpayments and refunds
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof PayerContact
     */
    emailOverpayment?: string;
    /**
     * The email address for other
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof PayerContact
     */
    emailOther?: string;
    /**
     * The phone number for claim submissions
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof PayerContact
     */
    phoneClaim?: string;
    /**
     * The phone number for reconsiderations and appeals
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof PayerContact
     */
    phoneAppeal?: string;
    /**
     * The phone number for medical records and supporting documentation
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof PayerContact
     */
    phoneDocumentation?: string;
    /**
     * The email address for overpayments and refunds
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof PayerContact
     */
    phoneOverpayment?: string;
    /**
     * The phone number for other
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof PayerContact
     */
    phoneOther?: string;
    /**
     * The fax number for claim submissions
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof PayerContact
     */
    faxClaim?: string;
    /**
     * The fax number for reconsiderations and appeals
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof PayerContact
     */
    faxAppeal?: string;
    /**
     * The fax number for medical records and supporting documentation
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof PayerContact
     */
    faxDocumentation?: string;
    /**
     * The fax number for overpayments and refunds
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof PayerContact
     */
    faxOverpayment?: string;
    /**
     * The fax number for other
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof PayerContact
     */
    faxOther?: string;
    /**
     * 
     * OpenAPI data type: {Address}
     * @type {Address}
     * @memberof PayerContact
     */
    addressClaim?: Address;
    /**
     * 
     * OpenAPI data type: {Address}
     * @type {Address}
     * @memberof PayerContact
     */
    addressAppeal?: Address;
    /**
     * 
     * OpenAPI data type: {Address}
     * @type {Address}
     * @memberof PayerContact
     */
    addressDocumentation?: Address;
    /**
     * 
     * OpenAPI data type: {Address}
     * @type {Address}
     * @memberof PayerContact
     */
    addressOverpayment?: Address;
    /**
     * 
     * OpenAPI data type: {Address}
     * @type {Address}
     * @memberof PayerContact
     */
    addressOther?: Address;
}

export function PayerContactFromJSON(json: any): PayerContact {
    return {
            'emailClaim': !exists(json, 'emailClaim') ? undefined : json['emailClaim'],
            'emailAppeal': !exists(json, 'emailAppeal') ? undefined : json['emailAppeal'],
            'emailDocumentation': !exists(json, 'emailDocumentation') ? undefined : json['emailDocumentation'],
            'emailOverpayment': !exists(json, 'emailOverpayment') ? undefined : json['emailOverpayment'],
            'emailOther': !exists(json, 'emailOther') ? undefined : json['emailOther'],
            'phoneClaim': !exists(json, 'phoneClaim') ? undefined : json['phoneClaim'],
            'phoneAppeal': !exists(json, 'phoneAppeal') ? undefined : json['phoneAppeal'],
            'phoneDocumentation': !exists(json, 'phoneDocumentation') ? undefined : json['phoneDocumentation'],
            'phoneOverpayment': !exists(json, 'phoneOverpayment') ? undefined : json['phoneOverpayment'],
            'phoneOther': !exists(json, 'phoneOther') ? undefined : json['phoneOther'],
            'faxClaim': !exists(json, 'faxClaim') ? undefined : json['faxClaim'],
            'faxAppeal': !exists(json, 'faxAppeal') ? undefined : json['faxAppeal'],
            'faxDocumentation': !exists(json, 'faxDocumentation') ? undefined : json['faxDocumentation'],
            'faxOverpayment': !exists(json, 'faxOverpayment') ? undefined : json['faxOverpayment'],
            'faxOther': !exists(json, 'faxOther') ? undefined : json['faxOther'],
            'addressClaim': !exists(json, 'addressClaim') ? undefined : AddressFromJSON(json['addressClaim']),
            'addressAppeal': !exists(json, 'addressAppeal') ? undefined : AddressFromJSON(json['addressAppeal']),
            'addressDocumentation': !exists(json, 'addressDocumentation') ? undefined : AddressFromJSON(json['addressDocumentation']),
            'addressOverpayment': !exists(json, 'addressOverpayment') ? undefined : AddressFromJSON(json['addressOverpayment']),
            'addressOther': !exists(json, 'addressOther') ? undefined : AddressFromJSON(json['addressOther']),
    };

}

export function PayerContactToForm(value?: PayerContact): any {
    let jsonVal = PayerContactToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function PayerContactToJSON(value?: PayerContact): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'emailClaim': cleanupBlankValuesForBackend(value.emailClaim),
            'emailAppeal': cleanupBlankValuesForBackend(value.emailAppeal),
            'emailDocumentation': cleanupBlankValuesForBackend(value.emailDocumentation),
            'emailOverpayment': cleanupBlankValuesForBackend(value.emailOverpayment),
            'emailOther': cleanupBlankValuesForBackend(value.emailOther),
            'phoneClaim': cleanupBlankValuesForBackend(value.phoneClaim),
            'phoneAppeal': cleanupBlankValuesForBackend(value.phoneAppeal),
            'phoneDocumentation': cleanupBlankValuesForBackend(value.phoneDocumentation),
            'phoneOverpayment': cleanupBlankValuesForBackend(value.phoneOverpayment),
            'phoneOther': cleanupBlankValuesForBackend(value.phoneOther),
            'faxClaim': cleanupBlankValuesForBackend(value.faxClaim),
            'faxAppeal': cleanupBlankValuesForBackend(value.faxAppeal),
            'faxDocumentation': cleanupBlankValuesForBackend(value.faxDocumentation),
            'faxOverpayment': cleanupBlankValuesForBackend(value.faxOverpayment),
            'faxOther': cleanupBlankValuesForBackend(value.faxOther),
            'addressClaim': AddressToJSON(value.addressClaim),
            'addressAppeal': AddressToJSON(value.addressAppeal),
            'addressDocumentation': AddressToJSON(value.addressDocumentation),
            'addressOverpayment': AddressToJSON(value.addressOverpayment),
            'addressOther': AddressToJSON(value.addressOther),
    };
}


